import { debug } from './debug'

/**
 * Get authentication token from URL query parameters
 * This is a temporary solution for testing until proper token management is implemented
 *
 * @returns The token from URL parameter or null if not present
 */
export function getTokenFromUrl(): string | null {
  if (typeof window === 'undefined') {
    debug.warn('[Auth] Window is undefined (SSR context)')
    return null
  }

  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('token')

  debug.log('[Auth] Token extraction:', {
    currentUrl: window.location.href,
    searchParams: window.location.search,
    hasToken: !!token,
    allParams: Object.fromEntries(urlParams.entries()),
  })

  return token
}
